@if (attribute) {
  <div [class.invisible]="isLoading">
    <app-field-label [attribute]="attribute"
    [passportId]="passportId"></app-field-label>
    <form>
      <ix-layout-grid class="px-0">
        <ix-row class="border-left">
          @for (nameIdAttribute of attribute.attributes; track nameIdAttribute) {
            <ix-col
              class="py-0 pe-0"
              size="6">
              @switch (nameIdAttribute.type) {
                @case ('text') {
                  <app-text-input
                    [attribute]="nameIdAttribute"
                    [passportId]="passportId"
                    [fullValuePath]="`${fullValuePath}.${nameIdAttribute.valuePath}`"
                    [saveFunction]="saveFunction"
                  [passData]="getData(nameIdAttribute.valuePath)"></app-text-input>
                }
                @case ('number') {
                  <app-number-input
                    [attribute]="nameIdAttribute"
                    [passportId]="passportId"
                    [fullValuePath]="`${fullValuePath}.${nameIdAttribute.valuePath}`"
                    [saveFunction]="saveFunction"
                  [passData]="getData(nameIdAttribute.valuePath)"></app-number-input>
                }
                @case ('select') {
                  <app-select-input
                    [attribute]="nameIdAttribute"
                    [passportId]="passportId"
                    [fullValuePath]="`${fullValuePath}.${nameIdAttribute.valuePath}`"
                    [saveFunction]="saveFunction"
                  [passData]="getData(nameIdAttribute.valuePath)"></app-select-input>
                }
              }
            </ix-col>
          }
        </ix-row>
      </ix-layout-grid>
    </form>
  </div>
}
<ix-spinner [class.d-none]="!isLoading"></ix-spinner>
